// import { useContext } from "react";
import { useContext, useEffect, useState } from "react";
import { useWebStoreContext } from "contexts/WebStoreProvider";
import { IShopPurchaseOfferSingleItem } from "contexts/WebStoreProvider/types";
import { SingleItemsSkeleton } from "../../skeleton";
import { offersApi } from "redux/apis";
import { ShopContext } from "../../index";
import { useDispatch } from "react-redux";
import { OfferSection } from "..";
//import useNewDay from "hooks/useNewDay";
import { useAppSelector } from "hooks";
import {
	IShopSection,
	selectShopSectionsState
} from "redux/slices/shop-sections";
import { sortByPriority } from "utils/sort";
import { ISectionMenuItem } from "components/PageTopNav";

export interface IOffer {
	sectionName: string;
}

const SingleItems = () => {
	const { authToken } = useWebStoreContext();
	const { shopSections } = useAppSelector(selectShopSectionsState);
	const [content, setContent] = useState<JSX.Element[]>();
	const dispatch = useDispatch();
	//const { newDay } = useNewDay();
	const {
		data: purchaseOffers
	}: { data?: { offers?: IShopPurchaseOfferSingleItem[] } } =
		offersApi.endpoints.getOffers.useQueryState({
			offerType: "singleItem",
			isAuthenticated: !!authToken?.value
		});
	const { sectionMenuData } = useContext(ShopContext);
	// Compared by value: sectionMenuData is rebuilt on every featured offers response, so depending
	// on it would refetch offers in a loop if the response is never deep-equal (e.g. `now`)
	const sectionsKey = JSON.stringify(
		shopSections?.mainShopSections?.map(
			({ name, startTime, endTime }: IShopSection) => ({
				name,
				startTime,
				endTime
			})
		)
	);

	useEffect(() => {
		if (
			!shopSections?.mainShopSections ||
			!purchaseOffers ||
			!sectionMenuData.length
		) {
			return;
		}

		const filteredSections = shopSections?.mainShopSections.filter((data) =>
			purchaseOffers.offers?.find(
				(of: IOffer) =>
					of.sectionName === data.name && of.sectionName !== "limited_deals"
			)
		);

		const content = filteredSections.map((data) => {
			const sectionOffers = sortByPriority(
				purchaseOffers?.offers?.filter(
					(of: IOffer) => of.sectionName === data.name
				)
			);

			const sectionProps = {
				data,
				sectionRef: sectionMenuData.find(
					(item: ISectionMenuItem) => item.name === data.name
				)?.sectionRef,
				uniqueKey: data.name
			};

			return (
				<OfferSection
					{...sectionProps}
					key={data.name}
					sectionOffers={sectionOffers as IShopPurchaseOfferSingleItem[]}
				/>
			);
		});

		setContent(content);
	}, [purchaseOffers, sectionMenuData]);

	useEffect(() => {
		dispatch(
			offersApi.util.invalidateTags([
				{
					type: "offersTag",
					id: "singleItem"
				}
			])
		);
	}, [sectionsKey]);

	// useEffect(() => {
	// 	if (newDay) {
	// 		refetch();
	// 	}
	// }, [newDay]);

	if (!content) {
		return <SingleItemsSkeleton />;
	}

	return <>{content}</>;
};

export default SingleItems;
